import { render, staticRenderFns } from "./StrBalanceAutocomplete.vue?vue&type=template&id=f4b83df8&"
import script from "./StrBalanceAutocomplete.vue?vue&type=script&lang=js&"
export * from "./StrBalanceAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports